import { formatCurrency, getCurrencySymbol } from '@angular/common';
import { Type } from '@angular/core';
import { Money } from 'src/business/services/client.generated';
import { PricePipeOption } from './price-pipe-option.model';
import { Guard } from '../../misselaineous/guards';
import { PricePipe } from '../price.pipe';
export namespace Price {
    export type PriceTransformer = (priceAsString: string, price: Partial<Money>, options: PricePipeOption) => string;

    export function fillPrice(priceAsString: string, price: Money, options: PricePipeOption): string {
        return options?.fill === true ? 'xxx.- ' : priceAsString;
    }
    export function simple(priceAsString: string, price: Money, options: PricePipeOption): string {
        let simplePrice = Intl.NumberFormat(
            document?.documentElement?.lang ?? 'da-DK',
            {
                style: "decimal",
                currency: price?.currency ?? 'DKK',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                // roundingMode: 'ceil',
            }
        )
            .format(Math.ceil(+((price?.amount??0) * 100).toFixed(5)) / 100);
           Math.fround
        if (options?.showZeroValue == true)
            return simplePrice;
        if (simplePrice.endsWith(',00'))
            simplePrice = simplePrice.replace(',00', ',-');
        if (simplePrice.endsWith('.00'))
            simplePrice = simplePrice.replace('.00', '.-');
        return simplePrice;
    }

    export function notation(priceAsString: string, price: Money, options: PricePipeOption): string {
        return `${options?.showNotation === true ? ((price.amount??0) < 0 ? '-' : '+') : ''}${priceAsString}`;
    }

    export function showZeroValue(priceAsString: string, price: Partial<Money>, option: PricePipeOption) {
        if (Guard.is.nullOrUndefined(price) ||
            Guard.is.nullOrUndefined(price.currency) ||
            Guard.is.nullOrUndefined(price.amount) ||
            price.currency === 'XXX' ||
            price.currency === 'xxx' ||
            option?.showZeroValue === false && price.amount === 0) {
            return '0';
        } else {
            return priceAsString;
        }
    }

    export function withCurrency(defaultCurrencyCode: string, locale: string, display: string = 'symbol', digitsInfo: string = '1.2-2') {
        const priceTransform = (
            value: number | string | null | undefined, currencyCode?: string,
            display: 'code' | 'symbol' | 'symbol-narrow' | string | boolean = 'symbol', digitsInfo?: string) => {
            if (!isValue(value)) return null;

            if (typeof display === 'boolean') {
                if (<any>console && <any>console.warn) {
                    console.warn(
                        `Warning: the currency pipe has been changed in Angular v5. The symbolDisplay option (third parameter) is now a string instead of a boolean. The accepted values are "code", "symbol" or "symbol-narrow".`);
                }
                display = display ? 'symbol' : 'code';
            }
            let currency: string = currencyCode || defaultCurrencyCode;
            if (display !== 'code') {
                if (display === 'symbol' || display === 'symbol-narrow') {
                    currency = getCurrencySymbol(currency, display === 'symbol' ? 'wide' : 'narrow', locale);
                } else {
                    currency = display;
                }
            }
            try {
                const num = strToNumber(value);
                return formatCurrency(num, locale, currency, currencyCode, digitsInfo);
            } catch (error) {
                throw invalidPipeArgumentError(PricePipe, error.message);
            }
        };

        const isValue = (value: number | string | null | undefined) => {
            return !(value == null || value === '' || value !== value);
        };

        /**
         * Transforms a string into a number (if needed).
         */
        const strToNumber = (value: number | string) => {
            // Convert strings to numbers
            if (typeof value === 'string' && !isNaN(Number(value) - parseFloat(value))) {
                return Number(value);
            }
            if (typeof value !== 'number') {
                throw new Error(`${value} is not a number`);
            }
            return value;
        };

        const invalidPipeArgumentError = (type: Type<any>, value: Object) => {
            return Error(`InvalidPipeArgument: '${value}' for pipe '${JSON.stringify(type)}'`);
        };

        return (priceAsString: string, price: Money, options: PricePipeOption) => Guard.not.nullOrEmpty(price) && price?.amount > 0 && price?.currency.toLowerCase() !== 'xxx' ?
            priceTransform(price.amount, price.currency, display, digitsInfo) :
            priceAsString;
    }
}
